import React from "react";
import PropTypes from "prop-types";
import ActionLogger from "action-logger";
import AtomPill from "components/source/atoms/atom-pill";
import MoleculeTooltip from "components/source/molecules/tooltip/molecule-tooltip";
import AtomDek from "components/source/atoms/atom-dek";
import { isEligibleForImmediateSwapUpgrade } from "helpers/membership-helpers";
import { isCanceled, isPausedWithoutItems, isPausedWithItems } from "helpers/membership-plan-helpers";
import { connect } from "react-redux";
import { compose } from "redux";
import { displayModal } from "actions/shared-actions";
import { membershipStatePropType, HighlightedComponentPropType } from "components/propTypes";
import { analytics, TOOLTIP } from "rtr-constants";
import { SwapCounterModal } from "components/source/membership/modals/SwapCounterModal";
import SwapCounterActions from "actions/swap-counter-actions";
import HighlightedComponentWrapper from "components/source/shared/highlighted_component/highlighted-component-wrapper.jsx";
export class MoleculeSwapCounter extends React.Component {
  static propTypes = {
    bagIsOpen: PropTypes.bool,
    dismissTooltip: PropTypes.func,
    displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    displaySwapCounterModal: PropTypes.func,
    highlightedComponent: HighlightedComponentPropType,
    initAddAShipmentTooltip: PropTypes.func,
    membershipState: membershipStatePropType.isRequired,
    swapCounterTooltipDismissed: PropTypes.bool, // has the tooltip already been viewed and dismissed?
    triggerAddAShipmentTooltip: PropTypes.func,
  };

  static highlightedId = "spotlight-swaps-counter";

  state = {
    swapsIncrease: null,
    swapsDecrease: null,
    delayAnimation: false,
  };

  componentDidMount() {
    const { initAddAShipmentTooltip } = this.props;
    initAddAShipmentTooltip();
  }

  shouldTooltipShow(componentProps) {
    const { displayedModal, swapCounterTooltipDismissed, swapCounterTooltipTriggered } = componentProps;
    return swapCounterTooltipTriggered && !swapCounterTooltipDismissed && !displayedModal;
  }

  componentDidUpdate(previousProps) {
    const tooltipWasOpen = this.shouldTooltipShow(previousProps);
    const tooltipIsOpen = this.shouldTooltipShow(this.props);
    const { membershipState, swapCounterTooltipDismissed, triggerAddAShipmentTooltip, displayedModal, bagIsOpen } =
      this.props;

    if (isEligibleForImmediateSwapUpgrade(membershipState) && !swapCounterTooltipDismissed) {
      setTimeout(() => triggerAddAShipmentTooltip(), 4000);
    }

    if (!tooltipWasOpen && tooltipIsOpen) {
      const { dismissTooltip } = this.props;
      const autoDismissTooltipAfterMS = 5000;
      setTimeout(() => {
        dismissTooltip();
      }, autoDismissTooltipAfterMS);
    }

    if (!previousProps.bagIsOpen && bagIsOpen) {
      this.setState({ swapsDecrease: false });
    }
    if (!previousProps.displayedModal && displayedModal) {
      this.setState({ delayAnimation: true });
    }

    if (previousProps.displayedModal && !displayedModal) {
      this.setState({ delayAnimation: false });
    }

    if (membershipState?.shipmentsCount < (previousProps?.membershipState?.shipmentsCount || 0)) {
      this.setState({ swapsDecrease: true, swapsIncrease: false });
    } else if (membershipState?.shipmentsCount > (previousProps?.membershipState?.shipmentsCount || 0)) {
      this.setState({ swapsIncrease: true, swapsDecrease: false });
    }
  }

  isPausedUser() {
    const { membershipState } = this.props;
    return isPausedWithItems(membershipState) || isPausedWithoutItems(membershipState);
  }

  hideCounter() {
    const { membershipState } = this.props;

    //Hide if unlimited or cancelled
    return !membershipState || !Number.isInteger(membershipState.monthlyShipmentLimit) || isCanceled(membershipState);
  }

  isInactive() {
    const { membershipState } = this.props;
    const shipments = membershipState.shipmentsCount;
    if (shipments < 1) {
      return isEligibleForImmediateSwapUpgrade(membershipState) ? false : true;
    }
    return false;
  }

  renderSvg() {
    return (
      <svg className="swap-svg" width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5975 2.38343L10.5942 2.37975C10.3243 2.0806 10.0544 1.78145 9.78444 1.48202C9.46682 1.12953 9.47673 0.605557 9.78444 0.251328C10.0814 -0.0881067 10.6531 -0.079417 10.9518 0.251328L11.0497 0.360097C11.113 0.43056 11.1762 0.500901 11.2406 0.571622C11.642 1.0175 12.0435 1.46246 12.4449 1.90741C12.7159 2.20766 12.9868 2.50791 13.2577 2.80845C13.3701 2.93333 13.4422 3.08251 13.474 3.23848C13.4878 3.29809 13.4964 3.35978 13.4993 3.42277C13.5077 3.61384 13.444 3.79341 13.3366 3.93925C13.313 3.97427 13.2867 4.00795 13.2577 4.04001L13.1599 4.1487L13.1596 4.14895C13.0964 4.21936 13.0332 4.28964 12.9689 4.3603C12.5675 4.80613 12.1661 5.25102 11.7647 5.69592C11.4937 5.99623 11.2228 6.29654 10.9518 6.59713C10.6342 6.94962 10.1062 6.91045 9.78444 6.59713C9.6343 6.44918 9.54355 6.19416 9.54355 5.98092C9.54355 5.75202 9.63595 5.52833 9.78444 5.3647L9.88225 5.25601L9.88247 5.25576C9.94576 5.18535 10.0089 5.11507 10.0732 5.04441C10.2989 4.79374 10.5246 4.54337 10.7503 4.29312H8.31997H6.07598C5.61401 4.29312 5.27163 3.89451 5.251 3.42277C5.23037 2.95279 5.64533 2.55241 6.07598 2.55241H6.88447H10.4303H10.75L10.5975 2.38343ZM3.24929 9.44583H3.56971H7.11553H7.92402C8.35467 9.44583 8.76963 9.04545 8.749 8.57547C8.72838 8.10373 8.38599 7.70512 7.92402 7.70512H5.68003H3.25058C3.47601 7.45517 3.70144 7.20509 3.92687 6.95472C3.99121 6.88397 4.05446 6.8136 4.11783 6.7431C4.15034 6.70693 4.18289 6.67073 4.21562 6.63443C4.36412 6.4708 4.45651 6.24711 4.45651 6.01822C4.45651 5.80498 4.36576 5.54995 4.21562 5.402C3.89139 5.08955 3.36588 5.05038 3.04826 5.40287C2.77726 5.70351 2.50626 6.00386 2.23526 6.30422C1.83389 6.74907 1.43252 7.19392 1.03114 7.6397C0.966805 7.71045 0.903548 7.78082 0.840181 7.85132C0.807667 7.88749 0.775125 7.92369 0.742392 7.95999C0.719706 7.98506 0.698661 8.01113 0.679258 8.03804C0.56229 8.18746 0.491944 8.37514 0.500739 8.57547C0.503447 8.63504 0.51126 8.69344 0.523774 8.75002C0.554304 8.91015 0.627176 9.0636 0.742392 9.19155C1.01343 9.49223 1.28447 9.79263 1.5555 10.093C1.95684 10.5378 2.35817 10.9826 2.75951 11.4284C2.82384 11.4991 2.88709 11.5695 2.95046 11.64C2.98297 11.6762 3.01552 11.7124 3.04826 11.7487C3.34692 12.0794 3.91863 12.0881 4.21562 11.7487C4.52498 11.3936 4.53324 10.8696 4.21562 10.5171C3.94461 10.2165 3.67361 9.91611 3.40261 9.61575C3.3515 9.55911 3.3004 9.50247 3.24929 9.44583Z"
        />
      </svg>
    );
  }

  renderNumber(swaps) {
    return <span className="swap-counter-text">{swaps}</span>;
  }

  renderCounter() {
    const { membershipState } = this.props;
    const swaps = membershipState.shipmentsCount;

    return (
      <AtomPill
        additionalClassName="swap-counter-pill"
        bold={true}
        inactive={this.isInactive()}
        id={this.constructor.highlightedId}>
        <div
          className={`swap-counter-text-container ${
            this.state.swapsDecrease && this.state.delayAnimation ? "counter-displace" : ""
          } ${this.state.swapsDecrease && !this.state.delayAnimation ? "counter-slide" : ""}`}>
          {this.renderNumber(swaps)}
          {this.state.swapsDecrease && this.renderNumber(swaps + 1)}
        </div>

        {this.renderSvg()}
      </AtomPill>
    );
  }

  onClick = () => {
    const {
      displaySwapCounterModal,
      membershipState: { id, membershipId, nextBillingDate, shipmentsCount },
    } = this.props;

    ActionLogger.logAction({
      object_type: analytics.OBJECT_TYPE.MEMBERSHIP_SWAP_COUNTER,
      action: analytics.SWAP.CLICK_SWAP_COUNTER,
      n_swaps: shipmentsCount,
      membership_id: membershipId,
      user_id: id,
    });

    // NW [EXPLANATION] 7/30/20: subscribers who are paused or
    // those with no swaps and no next billing date (cancelled or future-cancelled) will not see the modal
    if (this.isPausedUser() || (!shipmentsCount && !nextBillingDate)) {
      return;
    }

    displaySwapCounterModal();
  };

  tooltipContent = () => {
    const { membershipState } = this.props;
    // If user is eligible for immediate upgrade then we return the first block of text
    if (isEligibleForImmediateSwapUpgrade(membershipState)) {
      return (
        <>
          <AtomDek text={"Can&#39;t wait?"} mobileText={"Can&#39;t wait?"} customClass="hed-text" />
          <AtomDek
            text="You can add an extra shipment <br /> anytime you run out."
            mobileText="You can add an extra shipment <br /> anytime you run out."
            customClass="dek-text"
          />
        </>
      );
    }

    return (
      <>
        <AtomDek
          text={"We&#39;ll help you keep track!"}
          mobileText={"We&#39;ll help you keep track!"}
          customClass="hed-text"
        />
        <AtomDek
          text="Check here anytime to see how <br /> many shipments you have available."
          mobileText="Check here anytime to see how <br /> many shipments you have available."
          customClass={"dek-text"}
        />
      </>
    );
  };

  renderTooltip() {
    return (
      !this.isPausedUser() && (
        <MoleculeTooltip
          target={this.$target}
          isOpen={this.shouldTooltipShow(this.props)}
          placement={TOOLTIP.PLACEMENTS.BOTTOM}
          eventsEnabled={false}
          className="swap-counter-education-tooltip-container">
          {this.tooltipContent()}
        </MoleculeTooltip>
      )
    );
  }

  render() {
    if (this.hideCounter()) {
      return null;
    }

    const SwapButton = (
      <button
        className={`swap-counter-btn ${this.state.swapsIncrease ? "counter-bounce" : ""} `}
        onClick={this.onClick}
        ref={element => (this.$target = element)}>
        {this.renderCounter()}
      </button>
    );

    return (
      <div className="swap-counter">
        {this.props.highlightedComponent?.componentId === this.constructor.highlightedId ? (
          <HighlightedComponentWrapper>{SwapButton}</HighlightedComponentWrapper>
        ) : (
          SwapButton
        )}

        {this.renderTooltip()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    displayedModal,
    highlightedComponent,
    membershipState,
    swapCounterTooltipDismissed,
    swapCounterTooltipTriggered,
  } = state;

  return {
    displayedModal,
    highlightedComponent,
    membershipState,
    swapCounterTooltipDismissed,
    swapCounterTooltipTriggered,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dismissTooltip: () => {
      dispatch(SwapCounterActions.dismissSwapCounterTooltip());
    },
    displaySwapCounterModal: () => {
      dispatch(displayModal(SwapCounterModal.modalName));
    },
    initAddAShipmentTooltip: () => {
      dispatch(SwapCounterActions.initAddAShipmentTooltip());
    },
    triggerAddAShipmentTooltip: () => {
      dispatch(SwapCounterActions.swapCounterTooltipTriggered(true));
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(MoleculeSwapCounter);
